"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplainerBody = exports.HeadingNumberPrimary = exports.HeadingNumberSecondary = exports.CentredFlex = exports.CommissionPanelHeader = exports.StyledCommissionFeesPanel = exports.StyledCommissionPanel = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
exports.StyledCommissionPanel = styled_1.default.div `
	padding: 20px;
	border-radius: 5px;
	transition: background-color 0.2s, border 0.2s;
	position: relative;
	margin: 0 0;
	color: ${merlin_theme_1.default.palette.greyscale.white};
`;
exports.StyledCommissionFeesPanel = (0, styled_1.default)(exports.StyledCommissionPanel) `
	${({ bgColor }) => bgColor ? `background-color: ${bgColor};` : null};
	${({ background }) => background ? `background: ${background};` : null};
`;
exports.CommissionPanelHeader = styled_1.default.h3 `
	${merlin_theme_1.default.typography.a2};
	color: ${merlin_theme_1.default.palette.greyscale.white};
	margin-bottom: ${merlin_theme_1.default.layout.spacing.small};
`;
exports.CentredFlex = styled_1.default.div `
	display: flex;
	align-items: center;
	align-content: center;
`;
exports.HeadingNumberSecondary = styled_1.default.h2 `
	min-width: 60px;
	margin-right: ${merlin_theme_1.default.layout.spacing.large};
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	color: ${merlin_theme_1.default.palette.greyscale.white};
	font-weight: 700;
	font-size: 1.25rem;
`;
exports.HeadingNumberPrimary = styled_1.default.h1 `
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	min-width: 60px;
	margin-right: ${merlin_theme_1.default.layout.spacing.large};
	font-size: 2.5rem;
	color: ${merlin_theme_1.default.palette.greyscale.white};
	font-weight: 700;
`;
exports.ExplainerBody = styled_1.default.p `
	${merlin_theme_1.default.typography.d1};
	line-height: 1.0625rem;
	color: ${merlin_theme_1.default.palette.greyscale.white};
`;
//# sourceMappingURL=CommissionExplainer.styled.js.map